import { CheckoutArea, FlowStep } from 'types/checkout';

import { i18n } from 'lib/i18n';
import { checkoutFlowRawFactory, IProgressStep } from '../program/step/lib/application.util';

const steps: IProgressStep[] = [
	'package',
	{
		tabName: i18n.checkout.progress.teams,
		urlPath: 'league/teams',
	},
	'addons',
	{
		tabName: i18n.checkout.progress.familyMembers,
		urlPath: 'league/details',
	},
	{
		tabName: i18n.checkout.progress.application,
		urlPath: 'league/application',
	},
	'payment',
];

export const checkoutFlowRaw: FlowStep[] = checkoutFlowRawFactory(CheckoutArea.league, steps);
